import fetch from '@ixigo/fetch';

export interface QnA {
	q: string;
	a: string;
}

export interface FaqResponse {
	title: string;
	qnas: QnA[];
	noExpandedFaqs: number;
	noVisibleFaqs: number;
}

export const fetchFaq = async () => {
	try {
		const res = await fetch
			.get<string>(
				'action/content?searchFor=cmsContent&page=cabs&identifier=faqContent&token=home',
			)
			.text();
		return JSON.parse(res) as FaqResponse;
	} catch {
		return null;
	}
};
